import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MinibasketInitiatorService } from '@df/basket/minibasket/minibasket-initiator.service';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ISizeName } from '@df/core/service/client';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { TradeService } from '../../checkout/module/trade/trade.service';
import { iconsOptions } from '../../styles/cms.config';
import { NModalLayout } from '../../common/modal/layout/modal-layout.component';

export namespace NCmsMinibasket {
    export const BLOCK_ID = 'minibasket';

    export interface IBlockData extends Catalog.IBlockData<IBlockDataContent> {}

    export interface IBlockDataContent {
        icon?: string;
        text: string;
    }
}

@DfModal({
    id: NCmsMinibasket.BLOCK_ID,
    name: 'Minibasket',
    position: (sizeName: ISizeName) => (sizeName === 'S' ? 'bottom' : 'right'),
    config: size => (['S'].includes(size) ? NModalLayout.Bottom.modalConfig()(size) : NModalLayout.Right.modalConfig()(size)),

    initiators: [MinibasketInitiatorService],
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: sizeId => (['S', 'M'].includes(sizeId) ? ['S', 'M'] : ['L', 'X']),
    prerenderAllowed: false,
    forbiddenLocation: /^\/(basket|checkout|success)$/
})
@ICmsComponent<MinibasketComponent>({
    id: NCmsMinibasket.BLOCK_ID,
    block: {
        url: NCmsMinibasket.BLOCK_ID,
        autoload: 'bootstrap'
    },
    onDemandOnly: true,
    name: 'Minibasket',
    description: 'Minibasket Content',
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            title: 'Icon',
            key: 'icon',
            options: iconsOptions,
            previewMode: 'icon'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Text',
            required: true,
            default: 'Order before 12:00pm for same day delivery'
        }
    ]
})
@Component({
    selector: 'minibasket',
    templateUrl: './minibasket.html',
    styleUrls: ['./minibasket.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MinibasketComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: NCmsMinibasket.IBlockDataContent;
    private tradeService = inject(TradeService);
    constructor(
        protected basket: Basket,
        private modalRef: ModalRef<any>
    ) {
        super();
    }

    isSalable = false;

    override ngOnInit() {
        super.ngOnInit();
        this.subscriptions.add(this.basket.subscribe(() => this.onBasketUpdate()));
        this.onBasketUpdate();
    }

    private onBasketUpdate() {
        this.isSalable = this.basket.isSalable;
        this.detectChanges();
    }

    protected close() {
        this.modalRef.close();
    }

    itemTrackFn = (index: number, item: BasketItem) => item.id;
}
